import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { User, CreditCard, Gift, ArrowLeft } from "lucide-react";
import { ROUTES } from "../constants/routes";
import "../Biling.css";

function Settingsidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const isProfile = path === ROUTES.PROFILE || path === "/profile";
  const isBilling = path === ROUTES.BILLING || path === "/billing";
  const isReferral = path === ROUTES.REFERRALS || path === "/referrals";

  const handleBack = () => {
    navigate(ROUTES.DASHBOARD);
  };

  const menuItems = [
    {
      id: "profile",
      label: "Profile",
      path: ROUTES.PROFILE,
      icon: User,
      isActive: isProfile,
    },
    {
      id: "billing",
      label: "Billing",
      path: ROUTES.BILLING,
      icon: CreditCard,
      isActive: isBilling,
    },
    {
      id: "referral",
      label: "Referral",
      path: ROUTES.REFERRALS,
      icon: Gift,
      isActive: isReferral,
    },
  ];

  return (
    <aside className="Settingsidebar-main-div">
      <div className="Settingsidebar-top">
        {/* Dedicated Back to App button at top */}
        <button
          type="button"
          className="settings-sidebar-back-btn"
          onClick={handleBack}
          aria-label="Back to app"
        >
          <ArrowLeft size={16} strokeWidth={2} />
          <span>Back to app</span>
        </button>

        {/* Clean Browsing Menubar - Single List */}
        <nav className="settings-sidebar-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                type="button"
                className={`settings-nav-item ${item.isActive ? "active" : ""}`}
                onClick={() => navigate(item.path)}
              >
                <span className="settings-nav-icon-wrapper">
                  <Icon size={16} strokeWidth={item.isActive ? 2.2 : 1.8} />
                </span>
                <span className="settings-nav-label">{item.label}</span>
              </button>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}

export default Settingsidebar;
